/* ZYKORA · Visual Final V1 · excerpt sanitation */
(() => {
  const cleanHomeExcerpts = () => {
    document.querySelectorAll('.zv3-card-copy, .zv3-spotlight-copy > p').forEach((el) => {
      const original = el.textContent || '';
      const cleaned = original
        .replace(/(RESUMEN\s+RÁPIDO)(?=\S)/gi, '$1 · ')
        .replace(/superficies\s+lisas(?=Robot\b)/gi, 'superficies lisas. ')
        .replace(/([.!?])(?=[A-ZÁÉÍÓÚÑ])/g, '$1 ')
        .replace(/\s{2,}/g, ' ')
        .trim();
      if (cleaned && cleaned !== original) el.textContent = cleaned;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanHomeExcerpts, { once: true });
  } else {
    cleanHomeExcerpts();
  }
  document.addEventListener('shopify:section:load', cleanHomeExcerpts);
})();
